import PropTypes from 'prop-types'

export const SiteNavigation = PropTypes.arrayOf(
  PropTypes.shape({
    _key: PropTypes.string,
    _type: PropTypes.string,
    columnItems: PropTypes.arrayOf(
      PropTypes.oneOfType([
        PropTypes.objectOf({
          _key: PropTypes.string,
          _type: PropTypes.string,
          heading: PropTypes.string,
        }),
        PropTypes.objectOf({
          _key: PropTypes.string,
          _type: PropTypes.string,
          text: PropTypes.string,
          url: PropTypes.string,
        }),
      ]),
    ),
  }),
)

export const SiteNavigationSettings = PropTypes.shape({
  navigation: SiteNavigation,
})
